export const useStore = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  return user;
};
